import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { SafePipe } from "./pipes/sanitizer.pipe";
import { OnlyNumber } from "./directives/only-number.directive";
import { TwoDigitDecimaNumberDirective } from "./directives/two-decimal-number.directive";
import { TrimAddressPipe } from "./pipes/trim-address.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { AngularSvgIconModule } from "angular-svg-icon";
import { NgApexchartsModule } from "ng-apexcharts";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { TabsModule } from "ngx-bootstrap/tabs";
import { ClipboardModule } from "ngx-clipboard";
import { CarouselModule } from "ngx-owl-carousel-o";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SwapComponent } from "../components/swap/swap.component";
import { CasinoOfferHeaderComponent } from "../components/offers/casino-offer/casino-offer-header/casino-offer-header.component";
import { PrizeCardComponent } from './components/prize-card/prize-card.component';
import { RangeBarComponent } from './components/range-bar/range-bar.component';
import { WithdrawNftComponent } from './components/withdraw-nft/withdraw-nft.component';
import { SwiperSliderComponent } from "./components/swiper-slider/swiper-slider.component";
import { RoundAndTrimPipe } from './pipes/round-and-trim.pipe';
import { CustomImageComponent } from './components/custom-image/custom-image.component';
import { AccordionModule } from "ngx-bootstrap/accordion";
import { LoaderComponent } from './components/loader/loader.component';
import { MarqueeComponent } from "./components/marquee/marquee.component";

@NgModule({
  declarations: [
    SafePipe,
    TrimAddressPipe,
    OnlyNumber,
    TwoDigitDecimaNumberDirective,
    SwapComponent,
    CasinoOfferHeaderComponent,
    PrizeCardComponent,
    RangeBarComponent,
    WithdrawNftComponent,
    RoundAndTrimPipe,
    SwiperSliderComponent,
    CustomImageComponent,
    LoaderComponent,
    MarqueeComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ClipboardModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    TabsModule.forRoot(),
    NgxDatatableModule,
    NgApexchartsModule,
    CarouselModule,
    NgxChartsModule,
    TranslateModule.forChild({
      extend: true
    }),
    AccordionModule.forRoot(),
  ],
  exports: [
    SafePipe,
    TrimAddressPipe,
    OnlyNumber,
    TwoDigitDecimaNumberDirective,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ClipboardModule,
    NgxDatatableModule,
    NgApexchartsModule,
    CarouselModule,
    NgxChartsModule,
    BsDropdownModule,
    AngularSvgIconModule,
    TranslateModule,
    SwapComponent,
    TabsModule,
    TooltipModule,
    CasinoOfferHeaderComponent,
    PrizeCardComponent,
    RangeBarComponent,
    WithdrawNftComponent,
    RoundAndTrimPipe,
    CustomImageComponent,
    AccordionModule,
    LoaderComponent,
    MarqueeComponent
  ],
})
export class SharedModule { }
